import React from "react";
import { useMembersPage } from "./hooks/useMembersPage";
import MemberFormModal from "./components/MemberFormModal";
import { 
    Breadcrumb,
    NeoButton,
    NeoCard,
    NeoTabs,
    NeoTable,
    NeoSearch,
    NeoLoader
} from "../../components/Common";
import { useNavigate } from "react-router-dom";
import { getMembersColumns, MEMBER_STATUS_TABS } from "./constants";

const MembersPage = () => {
    const navigate = useNavigate();
    const {
        members,
        isInitialLoading,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        isModalOpen,
        handleToggleModal,
        formState,
        isSaving,
        handleSave,
        isReady
    } = useMembersPage();

    if (!isReady || isInitialLoading) {
        return <NeoLoader type="full-page" message="Carregando clientes..." />;
    }

    // Columns configuration for the NeoTable
    const columns = getMembersColumns(navigate);

    return (
        <React.Fragment>
            {/* Header com o título do módulo */}
            <div className="mb-3">
                <Breadcrumb title="Clientes" />
            </div>

            {/* Card com o cadastro de clientes em estilo Taça Outono */}
            <NeoCard
                title="Lista de Clientes"
                subtitle="Gestão geral de matrículas, dados cadastrais, atividades e histórico financeiro dos atletas."
                headerIcon="mdi-account-multiple-outline"
                headerActions={
                    <NeoButton
                        variant="primary"
                        size="sm"
                        icon="mdi-plus"
                        onClick={handleToggleModal}
                    >
                        Novo Cliente
                    </NeoButton>
                }
            >
                {/* Abas de Status de Alta Fidelidade */}
                <NeoTabs
                    tabs={MEMBER_STATUS_TABS.map(tab => ({ id: tab.value, label: tab.label }))}
                    activeTab={statusFilter}
                    onChangeTab={setStatusFilter}
                    style={{ marginBottom: '18px' }}
                />

                {/* Tabela Reativa Outonal de Clientes */}
                <NeoTable
                    columns={columns}
                    data={members}
                    defaultItemsPerPage={10}
                    emptyMessage="Nenhum cliente disponível"
                    onRowClick={(row) => navigate(`/members/${row.id}`)}
                    searchComponent={
                        <NeoSearch
                            placeholder="Buscar cliente..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            size="sm"
                            style={{ width: "260px" }}
                        />
                    }
                />
            </NeoCard>

            {/* Modal de Formulário */}
            <MemberFormModal
                isOpen={isModalOpen}
                toggle={handleToggleModal}
                onSave={handleSave}
                data={formState}
                isSaving={isSaving}
            />
        </React.Fragment>
    );
};

export default MembersPage;
